//FEDE export const API_URL = "http://local.dashbo.io:8000/";
export const API_URL = process.env.REACT_APP_API_URL;
// export const APP_URL = "https://app.dashbo.io/";
export const APP_URL = process.env.REACT_APP_APP_URL;
export const DSN = process.env.REACT_APP_DSN;
export const PUSHER_KEY = process.env.REACT_APP_PUSHER_KEY; //Pusher dev key is a92ba760efd560b0b710
export const INTERCOM_SPACE_ID = process.env.REACT_APP_INTERCOM_SPACE_ID;
//PRODUCCIÓN
export const TIKTOK_APP_ID = process.env.REACT_APP_TIKTOK_APP_ID;
// LINKEDIN
export const LINKEDIN_AUTHORIZATION_URL = process.env.REACT_APP_LINKEDIN_AUTHORIZATION_URL;

// SHOPIFY
// https://shopify.dev/docs/apps/build/authentication-authorization/access-tokens/authorization-code-grant#redirect-using-a-3xx-redirect
export const SHOPIFY_NONCE = process.env.REACT_APP_SHOPIFY_NONCE;
export const SHOPIFY_CLIENT_ID = process.env.REACT_APP_SHOPIFY_CLIENT_ID;
export const SHOPIFY_REDIRECT_URL = process.env.REACT_APP_SHOPIFY_REDIRECT_URL;

// Pusher para agente (cuenta separada)
export const AGENT_PUSHER_KEY = process.env.REACT_APP_AGENT_PUSHER_KEY;
export const AGENT_PUSHER_CLUSTER = process.env.REACT_APP_AGENT_PUSHER_CLUSTER || 'sa1';

// Dashbo MCP API (para Dashbo AI playground)
export const MCP_API_URL = process.env.REACT_APP_MCP_API_URL || 'https://mcp.dashbo.io';